function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as constants from 'modules/OrganizationAdmin/constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import OrganizationMembershipsAbstract from '../OrganizationMembershipsAbstract';
import styles from '../OrganizationAdmin.pcss';
import CancelInvitationModal from './CancelInvitationModal';
import CreateInvitationModal from './CreateInvitationModal';
import ResendInvitationModal from './ResendInvitationModal';
class InvitationOrganizationMemberships extends OrganizationMembershipsAbstract {
    onResendInvitation(organizationMembership) {
        this.onOpenModal(constants.RESEND_INVITATION_MODAL, organizationMembership);
    }
    onCancelInvitation(organizationMembership) {
        this.onOpenModal(constants.CANCEL_INVITATION_MODAL, organizationMembership);
    }
    get menuActions() {
        return [
            {
                key: 'resendInvitation',
                onClick: (organizationMembership)=>this.onResendInvitation(organizationMembership)
            },
            {
                key: 'cancelInvitation',
                onClick: (organizationMembership)=>this.onCancelInvitation(organizationMembership)
            }
        ];
    }
    renderEmpty() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.empty,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--bold mb-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.invitationOrganizationMembershipsEmptyLead))
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--small",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.invitationOrganizationMembershipsEmptyText))
                })
            ]
        });
    }
    renderModals() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CreateInvitationModal, {
                    openModalId: this.props.openModalId,
                    adminOrganizationMembership: this.props.adminOrganizationMembership,
                    onClose: ()=>this.onCloseModal()
                }),
                /*#__PURE__*/ _jsx(CancelInvitationModal, {
                    openModalId: this.props.openModalId,
                    adminOrganizationMembership: this.props.adminOrganizationMembership,
                    organizationMembership: this.activeOrganizationMembership,
                    onClose: ()=>this.onCloseModal()
                }),
                /*#__PURE__*/ _jsx(ResendInvitationModal, {
                    openModalId: this.props.openModalId,
                    adminOrganizationMembership: this.props.adminOrganizationMembership,
                    organizationMembership: this.activeOrganizationMembership,
                    onClose: ()=>this.onCloseModal()
                })
            ]
        });
    }
    renderHeaderMessage() {
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.invitationOrganizationMemberships));
    }
    renderHeaderControls() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: messages.buttons.createInvitation,
            className: "btn--sm m-0",
            onClick: ()=>this.props.onOpenModal(constants.CREATE_INVITATION_MODAL)
        });
    }
    constructor(props){
        super(props);
        this.status = 'Invitation';
    }
}
const mapStateToProps = (state)=>({
        organizationMemberships: selectors.organizationMemberships(state),
        isInProgress: selectors.isFetchOrganizationMembershipsInProgress(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedInvitationOrganizationMemberships = connect(mapStateToProps, mapDispatchToProps)(InvitationOrganizationMemberships);
export default ConnectedInvitationOrganizationMemberships;
